import ru from "./ru";
import uz from "./uz";

export default {
  ...ru,
  ...uz,
};
